module.exports = __webpack_public_path__ + "img/cross-browser.419e3168.png";